/**
 * O QUE O REGISTRO DA REALIZAÇÃO JÁ SABE (31/10/2026, o desenho do lançamento
 * de abastecimento levado à manutenção).
 *
 * O dia nasce HOJE: quem registra a preventiva quase sempre registra a que
 * acabou de fazer. A leitura nasce com a última leitura da máquina QUANDO ela
 * foi tirada no mesmo dia da realização: no dia de hoje, é o número que o
 * mecânico ia copiar do painel. Em outro dia, a leitura de hoje não é a daquele
 * dia, e o campo fica vazio, com a última leitura só na etiqueta. Pura.
 */
import { diaDaOperacao } from '@/lib/dia-da-operacao';

export function leituraSugerida(
  vencimento: { readonly leituraAtual: number | null; readonly leituraAtualEm: string | null },
  dia: string,
): number | null {
  if (vencimento.leituraAtual === null || vencimento.leituraAtualEm === null || dia === '') return null;
  const lidaEm = new Date(vencimento.leituraAtualEm);
  if (Number.isNaN(lidaEm.getTime())) return null;
  return diaDaOperacao(lidaEm) === dia ? vencimento.leituraAtual : null;
}
